// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React, { ReactNode } from 'react';
import { Box, useTheme } from '@mui/system';
import { Typography } from '@mui/material';
import stylesDef from './styles';

interface IEmptyStateCardProps {
  // The glyph shown in the card's circular badge.
  icon: ReactNode;
  // What is missing, then what the reader can do about it.
  title: string;
  description: string;
}

// AUT-6432: the dashboard's empty sections are cards, not bare sentences - a circular badge
// above two centred lines. Shared because the folders and projects sections show the same
// shape with a different glyph and message.
export const EmptyStateCard = ({ icon, title, description }: IEmptyStateCardProps) => {
  const theme = useTheme();
  const styles = stylesDef(theme);

  return (
    <Box sx={styles.card}>
      <Box sx={styles.iconBadge}>{icon}</Box>
      <Typography sx={styles.title}>{title}</Typography>
      <Typography sx={styles.description}>{description}</Typography>
    </Box>
  );
};

export default EmptyStateCard;
